<p-overlayPanel
    #op
    [appendTo]="'body'"
    [style]="{ width: '260px', maxWidth: '90vw', '--overlayArrowLeft': 'calc(100% - 3.2rem)' }"
    styleClass="profile-overlay"
>
    <ng-template pTemplate>
        <div class="card-container profile">
            <div class="profile-header">
                <img
                    class="round profile-pic"
                    src="data:image/jpeg;base64,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"
                    alt="user"
                />
                <div class="profile-meta">
                    <h3>
                        {{ _globals.userInfo?.firstName }}
                        {{ _globals.userInfo?.lastName }}
                    </h3>
                    <p class="username" [title]="_globals.userInfo?.username">{{ _globals.userInfo?.username }}</p>
                    <p class="phone">
                        {{ _globals.generatePhoneFormatUS(_globals.userInfo?.businessSetup[0]?.phone) }}
                    </p>
                </div>
            </div>

            <div class="profile-actions">
                <button
                    pButton
                    pRipple
                    type="button"
                    label="Change Password"
                    class="p-button-outlined p-button-sm"
                    (click)="changePasswordClicked()"
                ></button>
                <button
                    pButton
                    pRipple
                    type="button"
                    label="Sign out"
                    class="p-button-sm p-button-danger"
                    (click)="logoutButtonClicked()"
                ></button>
            </div>
        </div>
    </ng-template>
</p-overlayPanel>
<p-sidebar [(visible)]="_globals.ShowHelpSidebar" position="right" [modal]="true" header="Contact Us">
    <div class="p-d-flex p-jc-around p-ai-center p-flex-wrap text-center">
        <div class="p-m-3">
            <i class="pi pi-phone" style="font-size: 2rem; color: var(--brandColor);"></i>
            <p class="mt-2 mb-1">Phone</p>
            <a href="tel:+1 832-626-3322 "><strong>+1 832-626-3322 </strong></a>
        </div>
        <p-divider></p-divider>
        <div class="p-m-3">
            <i class="pi pi-envelope" style="font-size: 2rem; color: var(--brandColor);"></i>
            <p class="mt-2 mb-1">Email</p>
            <a href="mailto:support@lincsell.com"><strong>support@lincsell.com</strong></a>
        </div>
        <p-divider></p-divider>
        <div class="p-m-3">
            <i class="pi pi-globe" style="font-size: 2rem; color: var(--brandColor);"></i>
            <p class="mt-2 mb-1">Support</p>
            <a href="https://lincsell.com/24-7-support/" target="_blank">Visit Support Page</a>
        </div>
        <p-divider></p-divider>
    </div>
</p-sidebar>
<div class="layout-topbar">
    <a
        class="layout-topbar-logo"
        routerLink=""
        *ngIf="!_globals.moveMainMenuToggleSwitch"
    >
        <img
            [src]="_globals.whiteLabel.logo"
            alt="logo"
            height="350"
            style="margin-left: 0px !important "
        />
    </a>

    <div class="topbar-left" style="display: flex; align-items: center; align-content: center">
        <!-- <img [src]="_globals.whiteLabel.logo" alt="logo" height="350" /> -->
        <a
            class="p-link layout-menu-button layout-topbar-button"
            href="#"
            (click)="appMain.toggleMenu($event)"
        >
            <i class="pi pi-bars"></i>
        </a>
        <span class="business-name" *ngIf="isYouksStoreUser || _businessSetupProgress.isBusinessInfoComplete">
            {{ _globals.userInfo?.businessSetup[0]?.businessDisplayName }}
        </span>
    </div>

    <div class="topbar-mobile-status" [class.plan-open]="planPillExpanded">
        <div class="plan-promo-pill" *ngIf="!_abd.isAdmin && (isFreeTrial || isFreePlan)">
            <span class="plan-promo-copy" (click)="togglePlanPill()">
                <span class="plan-promo-dot"><span></span></span>
                <span class="plan-promo-text plan-text-full" *ngIf="isFreeTrial && freeTrialEndDate">Free access ends {{ freeTrialEndDate | date : "MMM d, y" }}</span>
                <span class="plan-promo-text plan-text-full" *ngIf="isFreeTrial && !freeTrialEndDate">You're on {{ currentPlanName }} — free for now</span>
                <span class="plan-promo-text plan-text-full" *ngIf="!isFreeTrial && isFreePlan">You're on the Free plan</span>
                <span class="plan-promo-text plan-text-short">{{ isFreeTrial ? "Free trial" : "Free plan" }}</span>
            </span>
            <div class="plan-promo-cta" *ngIf="!isYouksStoreUser && isFreePlan" (click)="goToSubscription()">Upgrade</div>
        </div>
        <a
            class="setup-progress-pill setup-progress-pill-mobile"
            *ngIf="!isYouksStoreUser && setupCompletedCount !== null && setupCompletedCount < setupTotalCount"
            (click)="goToBusinessSetup()"
            title="Finish setting up your business"
        >
            <span class="setup-progress-track">
                <span class="setup-progress-fill" [style.width.%]="(setupCompletedCount / setupTotalCount) * 100"></span>
            </span>
            <span class="setup-progress-label">{{ setupCompletedCount }}/{{ setupTotalCount }}</span>
        </a>
    </div>

    <a
        class="p-link layout-topbar-menu-button layout-topbar-button"
        href="#"
        title="Toggle Sidebar"
        (click)="toggleProfilePanel($event)"
    >
        <i class="pi pi-ellipsis-v"></i>
    </a>
<!-- //---to be hidden begin -->
<!-- W: {{_abd.getScreenWidth}}     H: {{_abd.getScreenHeight}} -->
<!-- //---to be hidden end -->
    <div
        class="layout-topbar-menu"
        [ngClass]="{
            'layout-topbar-menu-mobile-active': appMain.topMenuActive
        }"
    >
<!-- <div class="flex align-items-center justify-content-center cursor-pointer" *ngIf="!_abd.isAdmin">
<span class="check_In_btn" (click)="isCheckIn()" *ngIf="!_userServices.isCurrentCheckIn">
  <i class="pi pi-clock"></i>   Check-In
</span>
<span class="check_Out_btn" (click)="isCheckIn()" *ngIf="_userServices.isCurrentCheckIn">
  <i class="pi pi-clock"></i>   Check-Out
</span>
</div> -->
        <!-- <a href="#" class="p-link layout-topbar-button">
            <i class="pi pi-calendar"></i>
            <span>Calendar</span>
        </a> -->
        <a class="p-link layout-topbar-button" style="display: none">
            <i
                class="pi pi-cog"
                (click)="settingsClicked()"
                style="color: var(--gray-300)"
            ></i>
            <span>Settings</span>
        </a>
        <div class="plan-promo-pill plan-promo-pill-desktop" *ngIf="!_abd.isAdmin && (isFreeTrial || isFreePlan)">
            <span class="plan-promo-copy">
                <span class="plan-promo-dot"><span></span></span>
                <span class="plan-promo-text" *ngIf="isFreeTrial && freeTrialEndDate">Free access ends {{ freeTrialEndDate | date : "MMM d, y" }}</span>
                <span class="plan-promo-text" *ngIf="isFreeTrial && !freeTrialEndDate">You're on {{ currentPlanName }} — free for now</span>
                <span class="plan-promo-text" *ngIf="!isFreeTrial && isFreePlan">You're on the Free plan</span>
            </span>
            <div class="plan-promo-cta" *ngIf="!isYouksStoreUser && isFreePlan" (click)="goToSubscription()">Upgrade</div>
        </div>
        <a
            class="setup-progress-pill setup-progress-pill-desktop"
            *ngIf="!isYouksStoreUser && setupCompletedCount !== null && setupCompletedCount < setupTotalCount"
            (click)="goToBusinessSetup()"
            title="Finish setting up your business"
        >
            <span class="setup-progress-track">
                <span class="setup-progress-fill" [style.width.%]="(setupCompletedCount / setupTotalCount) * 100"></span>
            </span>
            <span class="setup-progress-label">Setup {{ setupCompletedCount }}/{{ setupTotalCount }}</span>
        </a>
        <a #profileTrigger (click)="toggleProfilePanel($event, profileTrigger)" class="p-link layout-topbar-button profile-button" title="Open profile menu">
            <span class="profile-avatar-wrap" aria-hidden="true">
                <img
                    class="w-full"
                    src="data:image/jpeg;base64,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"
                    alt="user"
                />
                <span class="profile-status-dot"></span>
            </span>
            <span class="profile-trigger-copy">
                <span class="profile-trigger-name">
                    {{ _globals.userInfo?.firstName }} {{ _globals.userInfo?.lastName }}
                </span>
            </span>
            <i class="pi pi-angle-down profile-trigger-icon"></i>
        </a>
        <!-- <div style="margin-top:15px; color: var(--blue-200)">{{_globals.userInfo?.firstName}} {{_globals.userInfo?.lastName}}</div> -->
    </div>

    <!-- <p-breadcrumb [model]="breadcrumbs"></p-breadcrumb> -->
</div>
